// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"104bc747","453":"911a5674","656":"4588399c","801":"b62e9311"}[chunkId] + ".chunk.js";
};